import { render, staticRenderFns } from "./IdentifyAgency.vue?vue&type=template&id=4e9ad78e"
import script from "./IdentifyAgency.vue?vue&type=script&lang=js"
export * from "./IdentifyAgency.vue?vue&type=script&lang=js"
import style0 from "./IdentifyAgency.vue?vue&type=style&index=0&id=4e9ad78e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports